<template>
    <div class="consultation-wrap">
        <bread-crumb :bread-list="breadList" />
        <div class="consultation-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">会诊管理</span>
            </div>

            <div class="table-wrap">
                <el-table :data="dataList"
                          v-loading="loading"
                          stripe
                          style="width: 100%">
                    <el-table-column label="序号"
                                     width="80px">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="name"
                                     label="会诊名称">
                    </el-table-column>

                    <el-table-column label="状态">
                        <template slot-scope="{row}">
                            <div v-if="row.state === 'ONLINE'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已上线</span>
                            </div>
                            <div v-if="row.state === 'OFFLINE'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已下线</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="排序">
                        <template slot-scope="{row}">
                            <div class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="handleMoveIndex(row.clinicId, 'UP')"></i>

                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="handleMoveIndex(row.clinicId, 'DOWN')"></i>

                                <i class="iconfont icon-zhiding icon-off"
                                   v-if="row.noMoveUp"></i>
                                <i class="iconfont icon-zhiding icon-on"
                                   @click="handleMoveTop(row.clinicId)"
                                   v-else></i>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作"
                                     width="180px">
                        <template slot-scope="{row}">
                            <div v-if="row.state === 'ONLINE'">
                                <span class="link-btn"
                                      @click="handlePutState(row)">下线</span>
                                <span class="link-btn"
                                      @click="handleClick(row)">编辑</span>
                            </div>
                            <div v-if="row.state === 'OFFLINE'">
                                <span class="link-btn"
                                      @click="handlePutState(row)">上线</span>
                                <span class="link-btn"
                                      @click="handleClick(row)">编辑</span>
                            </div>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { postClinicTypeList, putClinicTypeState, putTypeChangeIndex, putTypeChangeIndexTop } from '@/api/consultation'
export default {
    name: 'consultation',
    data () {
        return {
            breadList: [{ label: '运营管理' }, { label: '会诊管理' }],
            loading: false,
            dataList: [],
            page: {
                current: 1,
                total: 1,
                pageSize: 15
            }
        }
    },
    methods: {
        // 上下线
        async handlePutState (row) {
            let state = ''
            let message = ''
            if (row.state === 'ONLINE') {
                state = 'OFFLINE'
                message = '下线成功'
            } else if (row.state === 'OFFLINE') {
                state = 'ONLINE'
                message = '上线成功'
            }
            const { results } = await putClinicTypeState(row.clinicId, state)
            if (results === 'success') {
                this.$message({
                    message: message,
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.queryList(this.page.current)
            }
        },
        // 上移   下移
        async handleMoveIndex (clinicId, type) {
            const { results } = await putTypeChangeIndex(clinicId, type)
            if (results === 'success') {
                this.queryList(this.page.current)
            }
        },
        // 置顶
        async handleMoveTop (clinicId) {
            const { results } = await putTypeChangeIndexTop(clinicId)
            if (results === 'success') {
                this.queryList(this.page.current)
            }
        },
        handleClick (row) {
            if (row.name === '院士会诊') {
                this.$router.push({ path: '/operation/consultation/academician', query: { clinicId: row.clinicId } })
            } else if (row.name === '多学科会诊') {
                this.$router.push({ path: '/operation/consultation/multidisciplinary', query: { clinicId: row.clinicId } })
            } else if (row.name === '单学科会诊') {
                this.$router.push({ path: '/operation/consultation/single', query: { clinicId: row.clinicId } })
            }
        },
        handleCurrentChange (val) {
            this.page.current = val
            this.queryList()
        },
        async queryList () {
            let params = {
                page: this.page.current,
                size: this.page.pageSize
            }
            this.dataList = []
            this.loading = true
            const { results, total } = await postClinicTypeList(params)

            if (results && results.length > 0) {
                for (let i = 0; i < results.length; i++) {
                    let data = results[i]
                    if (data.orderIndexFlag === 'first') {
                        this.$set(data, 'noMoveUp', true)
                    }
                    if (data.orderIndexFlag === 'last') {
                        this.$set(data, 'noMoveDown', true)
                    }
                }
                this.dataList = results
                this.page.total = total
            } else {
                if (this.page.current > 1) {
                    this.page.current -= 1
                    this.queryList()
                }
            }
            this.loading = false
        }
    },
    mounted () {
        this.queryList()
    }
}
</script>

<style lang="scss">
.consultation-wrap {
    .consultation-content {
        min-height: 600px;
        margin: 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            padding: 20px;
            display: flex;
            align-items: center;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .table-wrap {
            padding: 0 20px;
            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }

            .status-warp {
                line-height: 12px;
                .el-badge {
                    height: 10px;
                    .el-badge__content {
                        width: 6px;
                        height: 6px;
                    }
                    .el-badge__content--success {
                        background: #4acfb1;
                    }
                    .el-badge__content--info {
                        background: #cccccc;
                    }
                }
                .status_text {
                    margin-left: 10px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    line-height: 12px;
                }
            }

            .status-on {
                display: flex;
                align-items: center;
                .icon-off {
                    color: #ccc;
                }
                .icon-on {
                    cursor: pointer;
                    color: #3b8fd9;
                }
                .icon-paixuxia {
                    font-size: 16px;
                    margin-right: 10px;
                }
                .icon-paixushang {
                    font-size: 16px;
                    margin-right: 10px;
                }
                .icon-zhiding {
                    font-size: 20px;
                }
            }
        }
        .pagination-wrap {
            padding: 0 20px;
        }
    }
}
</style>
